import { createContext } from 'react';
export const StudioHeaderContext = createContext<HTMLElement | null>(null);
